import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenAssetPropertyEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    public propertyTypes() {
        return `${this.getApiServerUrl()}/property-types`;
    }
}
